module.exports = __webpack_public_path__ + "img/36.9f1a13d9.jpg";